/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APICustomer } from './APICustomer';
import {
    APICustomerFromJSON,
    APICustomerFromJSONTyped,
    APICustomerToJSON,
} from './APICustomer';

/**
 * 
 * @export
 * @interface APIPaginatedCustomerList
 */
export interface APIPaginatedCustomerList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedCustomerList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedCustomerList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedCustomerList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APICustomer>}
     * @memberof APIPaginatedCustomerList
     */
    results: Array<APICustomer>;
}

/**
 * Check if a given object implements the APIPaginatedCustomerList interface.
 */
export function instanceOfAPIPaginatedCustomerList(value: object): value is APIPaginatedCustomerList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedCustomerListFromJSON(json: any): APIPaginatedCustomerList {
    return APIPaginatedCustomerListFromJSONTyped(json, false);
}

export function APIPaginatedCustomerListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedCustomerList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APICustomerFromJSON)),
    };
}

export function APIPaginatedCustomerListToJSON(value?: APIPaginatedCustomerList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APICustomerToJSON)),
    };
}

